/**
 * Defines the structure for analytics event parameters.
 * @property event_category - The category of the event.
 * @property event_action - The action of the event.
 * @property event_label - The label of the event.
 * @property [key: string] - Allows for additional arbitrary parameters.
 */
type AnalyticsEventParams = {
  event_category: string;
  event_action: string;
  event_label: string;
  [key: string]: any;
};

/**
 * Handles analytics events by formatting them and pushing them to the Google Tag Manager dataLayer.
 *
 * This function takes analytics event parameters, destructures them into standard GA fields
 * (event_category, event_action, event_label) and any additional parameters.
 * It then constructs an eventData object with a predefined event name 'GTM event To GA'
 * and maps the GA fields to their corresponding dataLayer variables (GA_event_category, etc.).
 * Finally, it ensures `window.dataLayer` exists and pushes the `eventData` to it.
 *
 * @param params - The analytics event parameters, conforming to the AnalyticsEventParams type.
 */
export const analyticsEventHandler = (params: AnalyticsEventParams) => {
  const { event_category, event_action, event_label, ...additionalParams } =
    params;

  const eventData = {
    event: 'GTM event To GA',
    GA_event_category: event_category,
    GA_event_action: event_action,
    GA_event_label: event_label,
    ...additionalParams,
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
};
